/**
 * useSzRestrictedAccess — feedback reutilizável de "sem permissão" (SZ).
 *
 * Quando um usuário sem permissão (ex.: Agente) tenta acessar uma área restrita
 * (começando pelas Configurações da conta — exclusiva de Admin), em vez de a ação
 * ser bloqueada silenciosamente, mostramos um toaster claro avisando o porquê.
 *
 * Reutilizável p/ futuras áreas restritas:
 *   const { canAccessAdminArea, notifyRestricted } = useSzRestrictedAccess();
 *   if (canAccessAdminArea()) router.push(...); else notifyRestricted('Configurações');
 *
 * O toaster usa o sistema nativo do Chatwoot (useAlert), que já se adapta a
 * tema claro/escuro.  Marker de build: SZ_RESTRICTED_ACCESS.
 */
import { useStore } from 'vuex';
import { useAlert } from 'dashboard/composables';
import {
  getUserRole,
  getUserPermissions,
} from 'dashboard/helper/permissionsHelper';

export function useSzRestrictedAccess() {
  const store = useStore();

  // Áreas administrativas (Configurações etc.) são exclusivas de Admin.
  const canAccessAdminArea = () => {
    const user = store.getters.getCurrentUser;
    const accountId = store.getters.getCurrentAccountId;
    const role = getUserRole(user, accountId);
    const permissions = getUserPermissions(user, accountId) || [];
    return role === 'administrator' || permissions.includes('administrator');
  };

  // Toaster informando a falta de permissão.
  const notifyRestricted = (areaLabel = 'Esta área') => {
    useAlert(
      `Acesso restrito: ${areaLabel} é exclusivo para administradores da conta. ` +
        `Se precisar de acesso, fale com um administrador.`
    );
  };

  return { canAccessAdminArea, notifyRestricted };
}

export default useSzRestrictedAccess;
